import { render, staticRenderFns } from "./Postfach_New.vue?vue&type=template&id=4f416688&scoped=true"
import script from "./Postfach_New.vue?vue&type=script&lang=js"
export * from "./Postfach_New.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f416688",
  null
  
)

export default component.exports